export const CONTENT_PRIMARY_BLUE = "#2563EB";
export const COLOR_WHITE = "#ffffff";
export const COLOR_OFFWHITE = "#f9f9f7";
/** solid page ground behind cards when the map is hidden (full-width medium card) */
export const COLOR_GROUND_LIGHT = "#EFF1F4";
export const COLOR_GROUND_DARK = "#1B1F1E";
/** one opaque step off the ground: hover on the resize gutter between two cards */
export const COLOR_GROUND_LIGHT_HOVER = "#DDE1E6";
export const COLOR_GROUND_DARK_HOVER = "#2A2E2D";
export const COLOR_SILVER = "#dadada";
export const COLOR_CONCRETE = "#999999";
export const COLOR_ASPHALT = "#666666";
export const COLOR_ONYX = "#3a3a3a";
export const COLOR_SUPERDARK = "#111111";
export const COLOR_BLACK = "#000000";

export const COLOR_MOVING = "#346DF1";
export const COLOR_IDLING = "#9CA3AF";

export const COLOR_SUCCESS = "#00CC00";
export const COLOR_ISSUE = "#fd4b29";
export const COLOR_UNASSIGNED = "#aaaaaa";
export const COLOR_SCHEDULED = "#263238";
export const COLOR_ASSIGNED_ACCEPTED = "#199DD5";
export const COLOR_IN_PROGRESS = "#FFA000";
export const COLOR_REJECTED = "#fd4b29";
// planned routes on the map: a calm slate line, light enough to never be taken for a driven (black) trip
export const COLOR_PLAN_LINE = "#64748B";
export const COLOR_PLAN_LINE_DARK = "#A3B1C6";
export const TEAM_ORANGE = "#DC7633";
export const COLOR_MARINE = "#4981CE";
export const COLOR_ACCENT = "#22C328";
export const COLOR_DANGER = "#FF5733";
export const COLOR_JOB_SELECTED = "#1766D4";
export const COLOR_COMPANY = "#8B008B";
export const COLOR_PLACE_DEFAULT = "#FA605C";
export const COLOR_PLACE_STROKE = "#7B3130";
export const COLOR_STATIONARY = COLOR_PLACE_DEFAULT;

export const COLOR_GREEN = "#22C328";
export const COLOR_YELLOW = "#D7D742";
export const COLOR_ORANGE = "#DD9A3C";
export const COLOR_RED = "#CC3333";
export const COLOR_PURPLE = "#8C28BD";
export const COLOR_BLUE = "#3366CC";
export const COLOR_GRAY = "#888888";

export const COLOR_FORMS = COLOR_MARINE;
export const COLOR_ALERTS = COLOR_DANGER;

export const COLOR_ARRAY = [
    '#B20000', // Dark Red
    '#B23000', // Dark Orange-Red
    '#B25900', // Dark Orange
    '#B27A00', // Dark Orange-Yellow
    '#B29B00', // Dark Gold
    '#B2B200', // Dark Yellow
    '#6EB200', // Dark Green-Yellow
    '#39B200', // Dark Chartreuse
    '#00B200', // Dark Lime (Pure Green)
    '#00B257', // Dark Spring Green
    '#00B27B', // Dark Medium Spring Green
    '#00B29C', // Dark Light Sea Green
    '#00B2B2', // Dark Aqua (Pure Cyan)
    '#0079B2', // Dark Deep Sky Blue
    '#003EB2', // Dark Dodger Blue
    '#0026B2', // Dark Royal Blue
    '#0000B2', // Dark Blue (Pure Blue)
    '#5800B2', // Dark Blue Violet
    '#6E00B2', // Dark Violet
    '#580058'  // Dark Purple
]

export const COLOR_LOGIN_BACKGROUND = "#242626";

export const COLOR_JOB_NEEDLE = COLOR_SUPERDARK;
export const COLOR_TRIP = "#33B5E5";
export const COLOR_LIVE = "#10b981";

export const COLOR_TRANSLUCENT = "rgba(0, 0, 0, 0.04)";
export const COLOR_TRANSLUCENT_ALTERNATE = "rgba(255, 255, 255, 0.08)";
export const COLOR_TRANSLUCENT_STRONG = "rgba(0, 0, 0, 0.08)";
export const COLOR_TRANSLUCENT_STRONG_ALTERNATE = "rgba(255, 255, 255, 0.16)";

// Selection blue - used for selected states (matching member items, chips, toggles)
export const COLOR_SELECTION_BLUE = "#3B82F6";

/**
 * One hue per person on the map when two to six people are on the board: their trail, route and
 * ring share it. Picked to read on road, satellite and dark maps and to stay apart from job states.
 */
export const MAP_PERSON_HUES = ["#346DF1", "#C2410C", "#0F8A6A", "#7C3AED", "#BE185D", "#4D7C0F"];
/** The same hues, lifted for dark maps so a line still reads against navy streets. */
export const MAP_PERSON_HUES_DARK = ["#7BA2FF", "#FF9A5C", "#3FD1A6", "#B69CFF", "#FF7AB8", "#B5D96A"];
/** A thin light edge around the black trip line on dark maps, so it stands off dark streets. */
export const MAP_TRIP_HALO_DARK = "#C8D0CC";
/** The server's GPS point colours by speed, one per 12 km/h, slow to fast (ProcessGeoJson.getSpeedColor). */
export const MAP_SPEED_COLORS = ["#FFFFFF", "#3DCBFE", "#19B4FE", "#0D82FE", "#074AFF", "#0E1FE6", "#4400FE", "#8F00F7", "#C700C9", "#FB009E", "#FB009E", "#F20098"];
/** A GPS point where the person was standing still. */
export const MAP_GPS_STANDING = "#22C328";
/** The speed scale sampled for the dock's swatch. */
export const MAP_SPEED_SCALE = ["#FFFFFF", "#3DCBFE", "#0D82FE", "#0E1FE6", "#8F00F7", "#FB009E"];
/** Free-flowing to jammed, for the traffic layer's swatch. */
export const MAP_TRAFFIC_SCALE = ["#3BB26B", "#F2B233", "#E5484D"];

// Glass surface tokens — the one recipe for panels floating over the map.
// Consume via theme.customColors (glass/glassBorder/hairline) or styles/theme.ts glassSurface().
export const GLASS_BG_LIGHT = "rgba(255, 255, 255, 0.72)";
export const GLASS_BG_DARK = "rgba(22, 24, 25, 0.72)";
export const GLASS_BORDER_LIGHT = "rgba(0, 0, 0, 0.06)";
export const GLASS_BORDER_DARK = "rgba(255, 255, 255, 0.09)";
export const HAIRLINE_LIGHT = "rgba(0, 0, 0, 0.08)";
export const HAIRLINE_DARK = "rgba(255, 255, 255, 0.12)";
/** filter chips: a hairline one step stronger than a row divider, so an idle chip still reads as a control */
export const CHIP_BORDER_LIGHT = "rgba(0, 0, 0, 0.14)";
export const CHIP_BORDER_DARK = "rgba(255, 255, 255, 0.2)";
export const COLOR_SELECTION_BLUE_LIGHT = "#60A5FA";
// The photo viewer stays dark in both themes, like any photo viewer; the scrim keeps white marks readable on photos.
export const COLOR_PHOTO_BACKDROP = "#0C0E10";
export const COLOR_PHOTO_SCRIM = "rgba(0, 0, 0, 0.3)";
// Dims the page under a job open big, in both themes.
export const COLOR_DIALOG_SCRIM = "rgba(20, 20, 19, 0.34)";
// The frame of the phone a job's form is shown on, in both themes.
export const COLOR_PHONE_BEZEL = "#151716";

/** The drawn map, phones and panels in the Dispatch upgrade loops (components/dispatch/upsell). */
export const UPSELL_SCENE_LIGHT = {
    map: "#E6E9EC", street: "#F7F8F9", road: "#FFFFFF", water: "#CBDDEE", park: "#D6E7D8",
    glass: "rgba(255, 255, 255, 0.93)", glassLine: "rgba(0, 0, 0, 0.09)", shadow: "rgba(0, 0, 0, 0.12)",
    pinRing: "#FFFFFF", phone: "#0E1013", phoneScreen: "#F4F5F7", placeFill: "rgba(250, 96, 92, 0.14)", xlsx: "#1D6F42",
};
export const UPSELL_SCENE_DARK = {
    map: "#1C2124", street: "#252B2F", road: "#2E353A", water: "#172633", park: "#1B2A22",
    glass: "rgba(24, 28, 31, 0.94)", glassLine: "rgba(255, 255, 255, 0.09)", shadow: "rgba(0, 0, 0, 0.4)",
    pinRing: "#181C1F", phone: "#000000", phoneScreen: "#15191C", placeFill: "rgba(250, 96, 92, 0.18)", xlsx: "#2E9E62",
};
/** The phone camera in the Photos loop, dark in both themes like any camera. */
export const UPSELL_CAMERA = { body: "#0B0C0E", mark: "#FFFFFF", mode: "#FFD60A" };
